@if (model()) {
<div class="tab">
    <mat-tab-group class="host" [selectedIndex]="index" (selectedIndexChange)="onSelect($event)">
        @for (tab of tabs(); track tab.path) {
        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon class="tab-icon">{{tab.icon}}</mat-icon>
            </ng-template>
            <ng-container [dynamic]="tab"></ng-container>
        </mat-tab>
        }
    </mat-tab-group>
</div>
}
